import { useCallback } from "react";
import type { OfferDiscount } from "@b2bportal/media-ads-api";
import { OfferDiscountEnum } from "@b2bportal/media-ads-api";
import { getPercentage, useI18nContext } from "@hopper-b2b/i18n";

/** "15% off" / "$50 off" from an HTS Media offer discount; `undefined` when there is none. */
export const useFormatOfferDiscount = () => {
  const { t, locale, formatFiatCurrency } = useI18nContext();

  return useCallback(
    (discount?: OfferDiscount): string | undefined => {
      if (discount == null) return undefined;
      const formatted =
        discount.OfferDiscount === OfferDiscountEnum.Percentage
          ? getPercentage(discount.discountPercent, locale)
          : formatFiatCurrency(
              {
                value: Math.abs(Number(discount.amount)),
                currencyCode: discount.currency,
              },
              { maximumFractionDigits: 0 }
            );
      return t("htsMedia.dialog.badge", { discount: formatted });
    },
    [t, locale, formatFiatCurrency]
  );
};
